var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "40px",
    viewBox: "0 0 41 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "intersect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "homepage-first-implementation",
    transform: "translate(-528.000000, -1712.000000)",
    fill: "#1E4E74",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s6-platform",
    transform: "translate(-1.000000, 1409.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(120.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(0.006920, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "service1-copy-9",
    transform: "translate(354.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(33.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "intersect",
    transform: "translate(22.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.828125,14.140625 L25.859375,14.140625 L25.859375,1.171875 C25.859375,0.5246875 25.3346875,0 24.6875,0 L1.171875,0 C0.5246875,0 0,0.5246875 0,1.171875 L0,24.6875 C0,25.3346875 0.5246875,25.859375 1.171875,25.859375 L14.140625,25.859375 L14.140625,38.828125 C14.140625,39.4753125 14.6653125,40 15.3125,40 L38.828125,40 C39.4753125,40 40,39.4753125 40,38.828125 L40,15.3125 C40,14.6653125 39.4753125,14.140625 38.828125,14.140625 Z M2.34375,23.515625 L2.34375,2.34375 L23.515625,2.34375 L23.515625,14.140625 L15.3125,14.140625 C14.6653125,14.140625 14.140625,14.6653125 14.140625,15.3125 L14.140625,23.515625 L2.34375,23.515625 Z M23.515625,16.484375 L23.515625,23.515625 L16.484375,23.515625 L16.484375,16.484375 L23.515625,16.484375 Z M37.65625,37.65625 L16.484375,37.65625 L16.484375,25.859375 L24.6875,25.859375 C25.3346875,25.859375 25.859375,25.3346875 25.859375,24.6875 L25.859375,16.484375 L37.65625,16.484375 L37.65625,37.65625 Z",
    id: "Shape"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.e051667e.svg";
export { ForwardRef as ReactComponent };